import { Component, Input,  OnChanges, SimpleChanges, ViewChild, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgForm } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, MessageService, ButtonLoader } from '../../../../core';
import { PessoaTermoLGPD } from '../pessoa-termo-lgpd';
import { isPessoaTermoLGPDStatusPendente, isPessoaTermoLGPDStatusImpresso, isPessoaTermoLGPDStatusAnexado } from '../status';
import { PessoaTermoLGPDAuthGuardService, PessoaTermoLGPDImprimirHttpService, PessoaTermoLGPDHttpService } from '../services';

interface Config {
    isStatusPendente: boolean;
    isStatusImpresso: boolean;
    isStatusAnexado: boolean;
    canImprimir: boolean;
    canImprimirNovamente: boolean;
    canAnexar: boolean;
    canOpenAnexo: boolean;
    canDelete: boolean;
}

@Component({
    selector: 'sgt-pessoa-termo-lgpd-form',
    templateUrl: './pessoa-termo-lgpd-form.component.html',
    styleUrls: ['./pessoa-termo-lgpd-form.component.less']
})
export class PessoaTermoLGPDFormComponent implements OnChanges, OnInit {
    config: Config;
    entity: PessoaTermoLGPD;
    isLoading: boolean;

    @Input() idPessoa: number;
    @Input() canEdit = true;
    @Input() delegateImprimir = false;
    @Output() onImprimir = new EventEmitter<void>();
    @Output() afterImprimir = new EventEmitter<void>();

    @ViewChild('form') form: NgForm;
    private isImprimirOnLoad = false;

    constructor(private activatedRoute: ActivatedRoute,
                private el: ElementRef,
                private messageService: MessageService,
                private pessoaTermoLGPDAuthGuardService: PessoaTermoLGPDAuthGuardService,
                private pessoaTermoLGPDImprimirHttpService: PessoaTermoLGPDImprimirHttpService,
                private pessoaTermoLGPDHttpService: PessoaTermoLGPDHttpService) { }

    ngOnInit(): void {
        // Query Params
        this.activatedRoute.queryParams.subscribe((params: Params) => {
            // Se deve imprimir o Termo LGPD ao carregar o cliente
            this.isImprimirOnLoad = params['imprimirTermoLGPD'] === 'true';
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'idPessoa') {
                this.create();
            }
        }
    }

    onChangeEntity(entity: PessoaTermoLGPD) {
        this.entity = entity;
        this.setConfig();
    }

    private setConfig() {
        this.config = {
            isStatusPendente: isPessoaTermoLGPDStatusPendente(this.entity?.status),
            isStatusImpresso: isPessoaTermoLGPDStatusImpresso(this.entity?.status),
            isStatusAnexado: isPessoaTermoLGPDStatusAnexado(this.entity?.status),
            canImprimir: this.pessoaTermoLGPDAuthGuardService.canImprimir(this.entity),
            canImprimirNovamente: this.pessoaTermoLGPDAuthGuardService.canImprimirNovamente(this.entity),
            canAnexar: this.pessoaTermoLGPDAuthGuardService.canAnexar(this.entity),
            canOpenAnexo: this.pessoaTermoLGPDAuthGuardService.canOpenAnexo(this.entity),
            canDelete: this.pessoaTermoLGPDAuthGuardService.canDelete(this.entity)
        }
    }

    private create() {
        if (this.idPessoa) {
            this.load();
        } else {
            const entity = new PessoaTermoLGPD();
            this.onChangeEntity(entity);
        }
    }

    private load() {
        this.entity = null;
        this.isLoading = true;
        this.pessoaTermoLGPDHttpService.load(this.idPessoa)
            .pipe(
                take(1)
            )
            .subscribe(
                entity => {
                    this.onChangeEntity(entity);
                    // Imprimindo ao carregar
                    if (this.isImprimirOnLoad) {
                        this.imprimir();
                    }
                },
                (error: ApiError) => this.messageService.error(error.message, error.cause, error),
                () => this.isLoading = false
            );
    }



    imprimirClick() {
        if (this.delegateImprimir) {
            this.onImprimir.emit();
        } else {
            this.imprimir();
        }
    }

    imprimir() {
        const btn = new ButtonLoader(jQuery(this.el.nativeElement).find('.btn-imprimir') as any);
        btn.loading('Imprimindo');
        this.pessoaTermoLGPDImprimirHttpService.imprimir(this.entity?.id)
            .then(entity => {
                this.onChangeEntity(entity);
                btn.reset();
                this.afterImprimir.emit();
            })
            .catch((error: ApiError) => {
                this.messageService.error(error.message, error.cause, error);
                btn.reset();
            });
    }

    delete() {
        this.pessoaTermoLGPDHttpService.delete(this.entity)
            .then(entity => this.onChangeEntity(entity))
            .catch(() => {});
    }

    /** Verifica se o form do Termo LGPD está válido */
    isValid(): boolean {
        if (this.canEdit) {
            return this.form.valid;
        }
        return true;
    }
}
